import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
// import { Observable, Subject } from 'rxjs';
import 'rxjs/add/operator/map';
import { Observable } from 'rxjs';

const httpOptions = {
  headers: new HttpHeaders({
    'Access-Control-Allow-Origin': '*'
  })
};

// <script type="text/javascript" src="https://www.oil-price.net/widgets/brent_crude_price_large/gen.php?lang=en"> </script>
// <noscript> To get the BRENT <a href="http://www.oil-price.net/dashboard.php?lang=en#brent_crude_price_large">oil price</a>, please enable Javascript.</noscript>	


@Injectable({
  providedIn: 'root'
})
export class TestSerService {

  test: any
  constructor(private _http: HttpClient) { }

  dailyForecast() {
    return this._http.get("http://www.oil-price.net/dashboard.php?lang=en#brent_crude_price_large",
      {
        responseType: "json", 
        headers: new HttpHeaders({
          'Access-Control-Allow-Origin': '*'
        })
      })
      .map((result: any) => {
        result.json()
      })

  }



}
